import React from 'react';
import * as ReactRedux from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import * as SelfServeBuilderActions from './SelfServeBuilderActions';

export class PaginationManager extends React.PureComponent {
  constructor(props) {
    super(props);

    this.setCurrentPage = this.setCurrentPage.bind(this);
  }

  setCurrentPage(e) {
    this.props.setCurrentPagePagination(e.target.value);
  }

  render() {
    return (
      <div className="builder-pagination">
        <div className="builder-pagination-wrapper">
          Page:&nbsp;
          <button
            className="builder-pagination-input-back"
            onClick={this.props.paginateBack}
          />
          <input
            className="builder-pagination-input"
            value={this.props.currentPageInterface}
            onChange={this.setCurrentPage}
          />
          <button
            className="builder-pagination-input-next"
            onClick={this.props.paginateNext}
          />
          &nbsp;of&nbsp;
          <span
            className="builder-page-total"
          >
            {this.props.pages.length}
          </span>
        </div>
      </div>
    );
  }
}

PaginationManager.propTypes = {
  pages: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  paginateNext: PropTypes.func.isRequired,
  paginateBack: PropTypes.func.isRequired,
  setCurrentPagePagination: PropTypes.func.isRequired,
  currentPageInterface: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]).isRequired,
};

const mapStateToProps = ({ SelfServeBuilderReducer }) => (SelfServeBuilderReducer);

const mapDispatchToProps = dispatch => (
  bindActionCreators({
    ...SelfServeBuilderActions,
  }, dispatch)
);

const PaginationManagerWithRedux = ReactRedux.connect(
  mapStateToProps,
  mapDispatchToProps,
)(PaginationManager);


export default PaginationManagerWithRedux;



// WEBPACK FOOTER //
// ./src-react/SelfServeBuilder/PaginationManager.jsx